import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { App, routeModules } from './app/App';
import type { RouteModule } from './app/App';
import { InitialDataContext, readInitialData } from './app/initialData';

const root = document.getElementById('root')!;
const app = <StrictMode><InitialDataContext.Provider value={readInitialData()}><App /></InitialDataContext.Provider></StrictMode>;
// Prerendered pages name their lazy page module; loading it first lets hydration finish in one pass.
const pageModule = root.dataset.module as RouteModule | undefined;

if (root.hasChildNodes()) {
  void (pageModule && pageModule in routeModules ? routeModules[pageModule]() : Promise.resolve()).finally(() => hydrateRoot(root, app));
} else {
  createRoot(root).render(app);
}
